import { Flex } from 'antd'
import { Image } from 'react-bootstrap'
import ClassName from 'clsx'
import { IconName } from '@/components/icon'
import FeatureIcons from '../feature-icons'
import Styles from './style.module.scss'

export interface ImageTextItemProps {
  title?: string
  subTitle?: string
  flag?: string
  cards?: { title: string; description: string }[]
  content?: {
    image?: string
    imageWidth?: number | string
    tag?: string[]
    title?: string
    noDotIndex?: number[]
    cards?: { title: string; description: string }[]
    subTitle?: string
    descriptions?: string[]
  }[]
  featureIcons?: {
    icon: IconName
    label: string
    description?: string
  }[]
}

export default function ImageText({ data }: { data: ImageTextItemProps[] }) {
  if (!data?.length) return null

  return (
    <Flex vertical className={Styles.wrapper}>
      {data.map((item, index) => (
        <Flex vertical key={index} className={Styles.itemWrapper}>
          {item?.title && <h2>{item?.title}</h2>}
          {!!item?.subTitle && <div className={Styles.subTitle}>{item?.subTitle}</div>}
          {!!item?.cards?.length && (
            <Flex className={Styles.cardsWrapper}>
              {item?.cards?.map((card, idx) => (
                <Flex vertical key={idx} className={Styles.card}>
                  {card?.title && <h4>{card?.title}</h4>}
                  {card?.description && <div>{card?.description}</div>}
                </Flex>
              ))}
            </Flex>
          )}
          {!!item?.content?.length && (
            <Flex vertical className={Styles.itemWrapper}>
              {item?.content?.map((content, idx) => {
                const haveRight =
                  content?.title ||
                  !!content?.tag?.length ||
                  !!content?.descriptions?.length ||
                  !!content?.cards?.length

                return (
                  <Flex key={idx} justify='center' className={Styles.item}>
                    {content?.image && (
                      <Image
                        src={content?.image}
                        alt={content?.title}
                        className={ClassName(Styles.image, haveRight && Styles.normal)}
                        style={{ width: content?.imageWidth }}
                      />
                    )}
                    {haveRight && (
                      <Flex vertical className={ClassName(Styles.main, content?.image && Styles.padding)}>
                        <Flex vertical className={Styles.header}>
                          {item?.flag && (
                            <div className={Styles.flag}>
                              {item?.flag}
                              {idx + 1}
                            </div>
                          )}
                          {content?.title && <h4>{content?.title}</h4>}
                          {!!content?.tag?.length && (
                            <Flex className={Styles.tagGroup}>
                              {content?.tag?.map(d => (
                                <div key={d} className={Styles.tag}>
                                  {d}
                                </div>
                              ))}
                            </Flex>
                          )}
                        </Flex>
                        {!!content?.cards?.length && (
                          <div className={Styles.innerCardsWrapper}>
                            {content?.cards?.map((card, idx) => (
                              <Flex vertical key={idx} className={Styles.card}>
                                {card?.title && <div className={Styles.title}>{card?.title}</div>}
                                {card?.description && <div className={Styles.description}>{card?.description}</div>}
                              </Flex>
                            ))}
                          </div>
                        )}
                        {!!content?.descriptions?.length && (
                          <div className={Styles.descriptions}>
                            {content?.descriptions?.map((d, idx) => (
                              <div
                                key={d}
                                className={ClassName(
                                  content?.descriptions.length > 1 &&
                                    !content?.noDotIndex?.includes(idx) &&
                                    Styles.order
                                )}
                              >
                                {d}
                              </div>
                            ))}
                          </div>
                        )}
                      </Flex>
                    )}
                  </Flex>
                )
              })}
            </Flex>
          )}

          {item?.featureIcons && <FeatureIcons data={item?.featureIcons} />}
        </Flex>
      ))}
    </Flex>
  )
}
